(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("lmTo9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FilterEstatesComponent", function () { return $64bc8f71204e793b$export$29bbdaf3d26432dd; });
$parcel$export(module.exports, "default", function () { return $64bc8f71204e793b$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $2mhIl = parcelRequire("2mhIl");

var $1QzIr = parcelRequire("1QzIr");

var $kcGXu = parcelRequire("kcGXu");

var $gLK27 = parcelRequire("gLK27");

var $22cn8 = parcelRequire("22cn8");

var $cUbQm = parcelRequire("cUbQm");

var $67EyS = parcelRequire("67EyS");

var $5jxwZ = parcelRequire("5jxwZ");

const $64bc8f71204e793b$var$CreateSearchProfileBtn = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>Promise.resolve((parcelRequire("lcDRl"))));
const $64bc8f71204e793b$export$29bbdaf3d26432dd = ({ setShowHideModal: setShowHideModal, objectListLayout: objectListLayout, handleShowLayout: handleShowLayout })=>{
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    const [tabIndex, setTabIndex] = (0, $dTCkE.useState)(-1);
    const [dataLayerClick, setDataLayerClick] = (0, $dTCkE.useState)(false);
    //<------------------States used for all dataLayers ----------------------->
    const [selectedCounties, setSelectedCounties] = (0, $dTCkE.useState)([]);
    const [selectedAreas, setSelectedAreas] = (0, $dTCkE.useState)([]);
    const [selectedMunicips, setSelectedMunicips] = (0, $dTCkE.useState)([]);
    const [selectedPolygons, setSelectedPolygons] = (0, $dTCkE.useState)(null);
    const [selectedEstateTypes, setSelectedEstateTypes] = (0, $dTCkE.useState)([]);
    const [selectedPriceMin, setSelectedPriceMin] = (0, $dTCkE.useState)();
    const [selectedPriceMax, setSelectedPriceMax] = (0, $dTCkE.useState)();
    const [selectedRoomMin, setSelectedRoomMin] = (0, $dTCkE.useState)();
    const [selectedRoomMax, setSelectedRoomMax] = (0, $dTCkE.useState)();
    const [selectedLivingSpaceMin, setSelectedLivingSpaceMin] = (0, $dTCkE.useState)();
    const [selectedLivingSpaceMax, setSelectedLivingSpaceMax] = (0, $dTCkE.useState)();
    const [selectedChargeMin, setSelectedChargeMin] = (0, $dTCkE.useState)();
    const [selectedChargeMax, setSelectedChargeMax] = (0, $dTCkE.useState)();
    const [selectedPlotMin, setSelectedPlotMin] = (0, $dTCkE.useState)();
    const [selectedPlotMax, setSelectedPlotMax] = (0, $dTCkE.useState)();
    const [selectedExtraCrits, setSelectedExtraCrits] = (0, $dTCkE.useState)([]);
    const [selectedAlignments, setSelectedAlignments] = (0, $dTCkE.useState)([]);
    const [selectedGreenEstate, setSelectedGreenEstate] = (0, $dTCkE.useState)(false);
    const [selectedHeadstart, setSelectedHeadstart] = (0, $dTCkE.useState)(false);
    const [selectedBidding, setSelectedBidding] = (0, $dTCkE.useState)(false);
    const [selectedSold, setSelectedSold] = (0, $dTCkE.useState)(false);
    const [showExtraCriterias, setShowExtraCriterias] = (0, $dTCkE.useState)(false);
    const [isScrollOverHeadline, setIsScrollOverHeadline] = (0, $dTCkE.useState)(false);
    //<------------------States above used for all dataLayers ----------------------->
    (0, $dTCkE.useEffect)(()=>{
        setTabIndex(-1);
        setDataLayerClick(false);
        const allTagIds = filterContext.tags.map((y)=>y.id);
        const allLabels = filterContext.tags.map((y)=>y.label);
        const allTexts = filterContext.tags.map((y)=>y.text);
        const allEstateTypes = filterContext.tags.map((x)=>x.estateType);
        const priceTag = filterContext.tags.map((x)=>x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).Price);
        const roomTag = filterContext.tags.map((x)=>x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).Room);
        const livingSpageTag = filterContext.tags.map((x)=>x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).LivingSpace);
        const chargeTag = filterContext.tags.map((x)=>x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).Charge);
        const plotAreaTag = filterContext.tags.map((x)=>x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).PlotArea);
        const greenEstateTag = filterContext.tags.map((x)=>x.type === (0, $cUbQm.FilterTypes).ShowGreenEstates && x.label === (0, $cUbQm.ServicesTitles).GreenEstate && x.isChecked);
        const headstartTag = filterContext.tags.map((x)=>x.type === (0, $cUbQm.FilterTypes).ShowOnlyHeadStart && x.isChecked);
        const soldTag = filterContext.tags.map((x)=>x.type === (0, $cUbQm.FilterTypes).ShowSold && x.isChecked);
        const polygonTag = filterContext.tags.map((x)=>x.type == (0, $cUbQm.FilterTypes).Polygons);
        let newSelectedCounties = [
            ...selectedCounties
        ];
        let newSelectedAreas = [
            ...selectedAreas
        ];
        let newSelectedMunicips = [
            ...selectedMunicips
        ];
        let newSelectedPolygons = selectedPolygons;
        let newSelectedEstateTypes = [
            ...selectedEstateTypes
        ];
        let newSelectedPriceMin = selectedPriceMin;
        let newSelectedPriceMax = selectedPriceMax;
        let newSelectedRoomMin = selectedRoomMin;
        let newSelectedRoomMax = selectedRoomMax;
        let newSelectedLivingSpaceMin = selectedLivingSpaceMin;
        let newSelectedLivingSpaceMax = selectedLivingSpaceMax;
        let newSelectedChargeMin = selectedChargeMin;
        let newSelectedChargeMax = selectedChargeMax;
        let newSelectedPlotMin = selectedPlotMin;
        let newSelectedPlotMax = selectedPlotMax;
        let newSelectedExtraCriterias = [
            ...selectedExtraCrits
        ];
        let newSelectedAlignments = [
            ...selectedAlignments
        ];
        let newSelectedGreenEstate = selectedGreenEstate;
        let newSelectedHeadstart = selectedHeadstart;
        let newSelectedBidding = selectedBidding;
        let newSelectedSold = selectedSold;
        filterContext.tags.forEach((x, i)=>{
            if (x.type === (0, $cUbQm.FilterTypes).Area && x.label && !newSelectedAreas.includes(x.label)) newSelectedAreas = [
                ...newSelectedAreas,
                x.label
            ];
            if (x.type === (0, $cUbQm.FilterTypes).County && x.id && !newSelectedCounties.includes(x.id)) newSelectedCounties = [
                ...newSelectedCounties,
                x.id
            ];
            if (x.type === (0, $cUbQm.FilterTypes).Municipality && x.id && !newSelectedMunicips.includes(x.id)) newSelectedMunicips = [
                ...newSelectedMunicips,
                x.id
            ];
            if (x.type === (0, $cUbQm.FilterTypes).Polygons && x.polygons && x.polygons.length > 0) //TODO POLYGONS should this be the value or the label??
            // newSelectedPolygons = x.label;
            newSelectedPolygons = x.polygons;
            if (x.type === (0, $cUbQm.FilterTypes).EstateType && x.estateType && !newSelectedEstateTypes.includes(x.estateType)) newSelectedEstateTypes = [
                ...selectedEstateTypes,
                x.estateType
            ];
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).Price && newSelectedPriceMin !== x.minVal.toString()) newSelectedPriceMin = x.minVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).Price && newSelectedPriceMax !== x.maxVal.toString()) newSelectedPriceMax = x.maxVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).Room && newSelectedRoomMin !== x.minVal.toString()) newSelectedRoomMin = x.minVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).Room && newSelectedRoomMax !== x.maxVal.toString()) newSelectedRoomMax = x.maxVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).LivingSpace && newSelectedLivingSpaceMin !== x.minVal.toString()) newSelectedLivingSpaceMin = x.minVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).LivingSpace && newSelectedLivingSpaceMax !== x.maxVal.toString()) newSelectedLivingSpaceMax = x.maxVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).Charge && newSelectedChargeMin !== x.minVal.toString()) newSelectedChargeMin = x.minVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).Charge && newSelectedChargeMax !== x.maxVal.toString()) newSelectedChargeMax = x.maxVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).PlotArea && newSelectedPlotMin !== x.minVal.toString()) newSelectedPlotMin = x.minVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).RangeTag && x.name === (0, $cUbQm.RangeTagNames).PlotArea && newSelectedPlotMax !== x.maxVal.toString()) newSelectedPlotMax = x.maxVal?.toString();
            if (x.type === (0, $cUbQm.FilterTypes).ExtraCritera && x.text && !newSelectedExtraCriterias.includes(x.text)) newSelectedExtraCriterias = [
                ...newSelectedExtraCriterias,
                x.text
            ];
            if (x.type === (0, $cUbQm.FilterTypes).Alignment && x.id && !newSelectedAlignments.includes(x.id)) newSelectedAlignments = [
                ...newSelectedAlignments,
                x.id
            ];
            if (x.type === (0, $cUbQm.FilterTypes).ShowGreenEstates) newSelectedGreenEstate = x.isChecked;
            if (x.type === (0, $cUbQm.FilterTypes).ShowSold) newSelectedSold = x.isChecked;
            if (x.type === (0, $cUbQm.FilterTypes).ShowOnlyHeadStart) newSelectedHeadstart = x.isChecked;
            if (x.type === (0, $cUbQm.FilterTypes).ShowBidding) newSelectedBidding = x.isChecked;
        });
        newSelectedCounties = newSelectedCounties.filter((x)=>allTagIds.includes(x));
        newSelectedAreas = newSelectedAreas.filter((x)=>allLabels.includes(x));
        newSelectedMunicips = newSelectedMunicips.filter((x)=>allTagIds.includes(x));
        if (!polygonTag.includes(true)) newSelectedPolygons = undefined;
        newSelectedEstateTypes = newSelectedEstateTypes.filter((x)=>allEstateTypes.includes(x));
        if (!priceTag.includes(true)) {
            newSelectedPriceMin = undefined;
            newSelectedPriceMax = undefined;
        }
        if (!roomTag.includes(true)) {
            newSelectedRoomMin = undefined;
            newSelectedRoomMax = undefined;
        }
        if (!livingSpageTag.includes(true)) {
            newSelectedLivingSpaceMin = undefined;
            newSelectedLivingSpaceMax = undefined;
        }
        if (!chargeTag.includes(true)) {
            newSelectedChargeMin = undefined;
            newSelectedChargeMax = undefined;
        }
        if (!plotAreaTag.includes(true)) {
            newSelectedPlotMin = undefined;
            newSelectedPlotMax = undefined;
        }
        newSelectedExtraCriterias = newSelectedExtraCriterias.filter((x)=>allTexts.includes(x));
        newSelectedAlignments = newSelectedAlignments.filter((x)=>allTagIds.includes(x));
        if (!greenEstateTag.includes(true)) newSelectedGreenEstate = undefined;
        if (!headstartTag.includes(true)) newSelectedHeadstart = undefined;
        if (!soldTag.includes(true)) newSelectedSold = undefined;
        //set initial state to new selected
        setSelectedCounties(newSelectedCounties);
        setSelectedAreas(newSelectedAreas);
        setSelectedMunicips(newSelectedMunicips);
        setSelectedPolygons(newSelectedPolygons);
        setSelectedEstateTypes(newSelectedEstateTypes);
        setSelectedPriceMin(newSelectedPriceMin);
        setSelectedPriceMax(newSelectedPriceMax);
        setSelectedRoomMin(newSelectedRoomMin);
        setSelectedRoomMax(newSelectedRoomMax);
        setSelectedLivingSpaceMin(newSelectedLivingSpaceMin);
        setSelectedLivingSpaceMax(newSelectedLivingSpaceMax);
        setSelectedChargeMin(newSelectedChargeMin);
        setSelectedChargeMax(newSelectedChargeMax);
        setSelectedPlotMin(newSelectedPlotMin);
        setSelectedPlotMax(newSelectedPlotMax);
        setSelectedExtraCrits(newSelectedExtraCriterias);
        setSelectedAlignments(newSelectedAlignments);
        setSelectedGreenEstate(newSelectedGreenEstate);
        setSelectedHeadstart(newSelectedHeadstart);
        setSelectedBidding(newSelectedBidding);
        setSelectedSold(newSelectedSold);
        let top = undefined;
        if (window.scrollY > 100 && filterContext.isBigScreen) top = 0;
        else if (filterContext.isSmallScreen && window.scrollY > 750) top = 650;
        if (top !== undefined) window.scrollTo({
            top: top,
            behavior: "smooth"
        });
    }, [
        filterContext.tags
    ]);
    (0, $dTCkE.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollPosition = window.scrollY || window.pageYOffset;
            setIsScrollOverHeadline(scrollPosition > 64);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    //initial check if map is open
    const isSmallScreen = (0, $67EyS.default)("(max-width: 55.9rem)");
    const hash = window.location.hash.substring(1);
    const isMapInHash = hash.includes("map");
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: `${isScrollOverHeadline ? "lg:h-[calc(100vh-64px)]" : "lg:h-[calc(100vh-124px)]"} bg-white lg:sticky lg:top-[64px] transition-all flex flex-col justify-between top-0 left-0 lg:w-full h-full lg:min-w-[25.8rem] lg:overflow-y-auto no-scrollbar lg:pt-3`,
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "bg-white lg:bg-none",
                children: [
                    filterContext.isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $1QzIr.default), {
                        inputLabel: (0, $cUbQm.Estates).SearchPlaceholder,
                        activeInput: false,
                        countySelected: false,
                        multipleEstateTypesSelected: false,
                        brokerOrOfficeTypesSelected: false,
                        commercialOrProject: false
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "hidden lg:flex justify-center pt-4 pb-1",
                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
                            onClick: ()=>handleShowLayout("map"),
                            className: "flex gap-2 text-blue700",
                            children: [
                                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                    className: "whitespace-nowrap",
                                    children: "S\xf6k p\xe5 karta"
                                }),
                                /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                    src: "/Images/Icons/map-pin-line-blue.svg",
                                    alt: "S\xf6k p\xe5 karta"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)((0, $2mhIl.EstateSelector), {}),
                    /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kcGXu.default), {
                        tabIndex: tabIndex,
                        showExtraCriterias: showExtraCriterias
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)((0, $gLK27.default), {
                        tabIndex: tabIndex,
                        setTabIndex: setTabIndex,
                        showExtraCriterias: showExtraCriterias,
                        setShowExtraCriterias: setShowExtraCriterias
                    })
                ]
            }),
            (!isSmallScreen || !isMapInHash) && /*#__PURE__*/ (0, $a9eYm.jsx)($64bc8f71204e793b$var$CreateSearchProfileBtn, {
                sessionId: filterContext.sessionId,
                setShowHideModalFunction: setShowHideModal,
                isScrollOverHeadline: isScrollOverHeadline
            }),
            dataLayerClick && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.HelmetProvider), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.Helmet), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)("script", {
                        children: `
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'filter_klick',
                    eventInfo: {
                      buttonText: ${(0, $cUbQm.Estates).SearchEstate}
                    }   
                });     
              `
                    })
                })
            }),
            filterContext.tags && filterContext.tags.length !== 0 && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.HelmetProvider), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.Helmet), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)("script", {
                        children: `
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'filter',
                  eventInfo: {
                    l\xe4n: ${selectedCounties.length ? `'${selectedCounties.sort()}'` : undefined},
                    kommun: ${selectedMunicips.length ? `'${selectedMunicips.sort()}'` : undefined},
                    omr\xe5de: ${selectedAreas.length ? `'${selectedAreas.sort()}'` : undefined},
                    boendetyp: ${selectedEstateTypes.length ? `'${selectedEstateTypes.sort()}'` : undefined},
                    pris: ${selectedPriceMin !== undefined && selectedPriceMax !== undefined ? `'${selectedPriceMin}-${selectedPriceMax}'` : undefined},
                    rum:  ${selectedRoomMin !== undefined && selectedRoomMax !== undefined ? `'${selectedRoomMin}-${selectedRoomMax}'` : undefined},
                    boarea:  ${selectedLivingSpaceMin !== undefined && selectedLivingSpaceMax !== undefined ? `'${selectedLivingSpaceMin}-${selectedLivingSpaceMax}'` : undefined},
                    avgift:  ${selectedChargeMin !== undefined && selectedChargeMax !== undefined ? `'${selectedChargeMin}-${selectedChargeMax}'` : undefined},
                    tomtarea:  ${selectedPlotMin !== undefined && selectedPlotMax !== undefined ? `'${selectedPlotMin}-${selectedPlotMax}'` : undefined},
                    nyckelord: ${selectedExtraCrits.length ? `'${selectedExtraCrits.sort()}'` : undefined},
                    inriktning: ${selectedAlignments.length ? `'${selectedAlignments.sort()}'` : undefined},
                    h\xe5llbar: ${selectedGreenEstate !== undefined ? `'true'` : undefined},
                    s\xe5ld: ${selectedSold !== undefined ? `'true'` : undefined},
                    kommande: ${selectedHeadstart !== undefined ? `'true'` : undefined},
                    budgivning: ${selectedBidding === true ? `'true'` : undefined},
                    vy: ${`'${objectListLayout}'`}
                  }})
              `
                    })
                })
            })
        ]
    });
};
var $64bc8f71204e793b$export$2e2bcd8739ae039 = $64bc8f71204e793b$export$29bbdaf3d26432dd;

});
parcelRegister("2mhIl", function(module, exports) {

$parcel$export(module.exports, "EstateSelector", function () { return $1fb6084a4510985b$export$45bc79b0e29827f; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $cUbQm = parcelRequire("cUbQm");

var $l8eky = parcelRequire("l8eky");

var $22cn8 = parcelRequire("22cn8");
const $1fb6084a4510985b$export$45bc79b0e29827f = ()=>{
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    function updateEstateTypeTags(estateType) {
        const existingTag = filterContext.tags.some((x)=>x.estateType === estateType && x.type === "estateType");
        //hard coded values below due to unidentified type of alignments
        let currentTags = filterContext.tags;
        let currentVisible = {};
        if (existingTag) {
            const filteredItems = filterContext.tags.filter((x)=>{
                return x.estateType !== estateType && !(estateType === (0, $cUbQm.EstateType).Agriculture && x.type === "alignment" && (0, $cUbQm.FarmCriteriasDefault).some((t)=>t.id === x.id)) && !(estateType === (0, $cUbQm.EstateType).Commercial && x.type === "alignment" && (0, $cUbQm.CommercialCriteriasDefault).some((t)=>t.id === x.id?.replace("-", "/")));
            });
            filterContext.setTags(filteredItems);
            currentVisible = updateNewFilterItems(filterContext, filteredItems);
            currentTags = filteredItems;
        } else {
            const newTags = [
                ...filterContext.tags,
                {
                    type: "estateType",
                    estateType: estateType
                }
            ];
            filterContext.setTags(newTags);
            currentVisible = updateNewFilterItems(filterContext, newTags);
            currentTags = newTags;
        }
        const filteredItems = currentTags.filter((x)=>{
            if (x.type === "extraCriteria") {
                const isInvisible = typeof currentVisible[x.id ?? ""] !== "object";
                if (isInvisible) return false;
            }
            return true;
        });
        filterContext.setTags(filteredItems);
    }
    function updateNewFilterItems(filterContext, filteredItems) {
        const selectedEstateTypesList = filteredItems.map((x)=>x.estateType);
        const tArray = {};
        Object.keys((0, $cUbQm.ExtraCriterias)).map((x)=>{
            const crit = (0, $cUbQm.ExtraCriterias)[x];
            selectedEstateTypesList.forEach((type)=>{
                if (type && crit.belongsTo.includes(type)) tArray[x] = crit;
            });
        });
        if (filterContext.visibleExtraCrits !== tArray) filterContext.setVisibleExtraCrits(tArray);
        return tArray;
    }
    const hasEstateTypeTag = (estate)=>{
        return filterContext.tags.some((t)=>t.estateType === estate && t.type === "estateType");
    };
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        id: "object-types",
        className: "justify-items-stretch gap-2 sm:gap-3 grid grid-cols-4 md:grid-cols-7 lg:grid-cols-4 my-4 mdplus:mb-4 px-3 lg:px-4 overflow-hidden",
        children: Object.entries((0, $cUbQm.EstateType)).filter((y)=>y[1] !== (0, $cUbQm.EstateType).OwnedApartment && y[1] !== (0, $cUbQm.EstateType).Premises).map(([, estate])=>/*#__PURE__*/ (0, $a9eYm.jsxs)("label", {
                className: `w-full justify-self-center font-icb select-none cursor-pointer py-3 flex flex-col rounded-md ${hasEstateTypeTag(estate) ? "bg-blue700 text-white" : "bg-grey50 text-blue700"}`,
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("input", {
                        className: "hidden",
                        tabIndex: 0,
                        type: "checkbox",
                        "aria-checked": "false",
                        checked: hasEstateTypeTag(estate),
                        onChange: (e)=>{
                            updateEstateTypeTags(estate);
                            (0, $l8eky.changeCheckboxAriaAttr)(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        width: "48",
                        height: "37",
                        className: "mx-auto w-11 h-11 self-center",
                        src: "/Images/Icons/objecttypes/" + (0, $l8eky.getLargeObjectTypeIconPath)(estate, hasEstateTypeTag(estate) === true ? "white" : "blue"),
                        alt: `Objektstyp ${estate}`
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "text-center text-xs sm:text-sm",
                        children: estate
                    })
                ]
            }, estate))
    });
};

});

parcelRegister("kcGXu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c0fe26364618562$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $22cn8 = parcelRequire("22cn8");

var $cUbQm = parcelRequire("cUbQm");

var $coHqv = parcelRequire("coHqv");

var $67EyS = parcelRequire("67EyS");

const $1c0fe26364618562$var$ExtraCriterias = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("i3fhg")));

const $1c0fe26364618562$var$CommercialCriterias = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("2K6uN")));

const $1c0fe26364618562$var$FarmCriterias = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("6887U")));

const $1c0fe26364618562$var$RangeSlidersExtraCriteria = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("7GeXm")));
const $1c0fe26364618562$var$ExtraCriteriasFilter = ({ tabIndex: tabIndex, showExtraCriterias: showExtraCriterias })=>{
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    const isBigDesktop = (0, $67EyS.default)("(min-width: 91rem)");
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        id: "extra-criterias",
        className: "md:grid lg:grid-cols-1 md:grid-cols-2 mb-3 duration-200 transition-all overflow-hidden",
        children: [
            filterContext.tags.some((t)=>t.type === "estateType" && (t.estateType === (0, $cUbQm.EstateType).Agriculture || t.estateType === (0, $cUbQm.EstateType).Commercial)) && showExtraCriterias && /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "px-3 md:px-0 divide-y bg-grey10 rounded-md mt-2",
                children: [
                    filterContext.tags.some((t)=>t.type === "estateType" && t.estateType === (0, $cUbQm.EstateType).Agriculture) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($1c0fe26364618562$var$FarmCriterias, {
                            tabIndex: tabIndex
                        })
                    }),
                    filterContext.tags.some((t)=>t.type === "estateType" && t.estateType === (0, $cUbQm.EstateType).Commercial) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($1c0fe26364618562$var$CommercialCriterias, {
                            tabIndex: tabIndex
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $coHqv.default), {
                tabIndex: tabIndex
            }),
            (showExtraCriterias || isBigDesktop) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($1c0fe26364618562$var$RangeSlidersExtraCriteria, {
                    tabIndex: tabIndex
                })
            }),
            showExtraCriterias && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($1c0fe26364618562$var$ExtraCriterias, {})
            })
        ]
    });
};
var $1c0fe26364618562$export$2e2bcd8739ae039 = $1c0fe26364618562$var$ExtraCriteriasFilter;

});
parcelRegister("coHqv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71fc51427b194050$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $22cn8 = parcelRequire("22cn8");

var $8hO8H = parcelRequire("8hO8H");

var $52Mqt = parcelRequire("52Mqt");

var $dOPQH = parcelRequire("dOPQH");

var $cUbQm = parcelRequire("cUbQm");
const $71fc51427b194050$var$RangeSliders = ({ tabIndex: tabIndex })=>{
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    const [filteredEstateTypes, setFilteredEstateTypes] = (0, $dTCkE.useState)([]);
    function updateRangeTags(name, minVal, maxVal) {
        const existingTag = filterContext.tags.some((x)=>x.name === name && x.type === "rangeTag");
        if (existingTag) filterContext.setTags(filterContext.tags.filter((x)=>{
            if (x.name === name && x.type === "rangeTag") {
                x.minVal = minVal;
                x.maxVal = maxVal;
            }
            return x;
        }));
        else filterContext.setTags([
            ...filterContext.tags,
            {
                name: name,
                minVal: minVal,
                maxVal: maxVal,
                type: "rangeTag"
            }
        ]);
    }
    (0, $dTCkE.useEffect)(()=>{
        const filteredEstateTypes = filterContext.tags.filter((tag)=>tag.type === "estateType").map((tag)=>tag.estateType);
        setFilteredEstateTypes(filteredEstateTypes);
    }, [
        filterContext.tags
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $52Mqt.PriceRangeSlider), {
                updateRangeTags: updateRangeTags,
                tabIndex: tabIndex
            }),
            (filteredEstateTypes.length === 0 || filteredEstateTypes.includes((0, $cUbQm.EstateType).House) || filteredEstateTypes.includes((0, $cUbQm.EstateType).Cottage) || filteredEstateTypes.includes((0, $cUbQm.EstateType).Cooperative) || filteredEstateTypes.includes((0, $cUbQm.EstateType).Project) || filteredEstateTypes.includes((0, $cUbQm.EstateType).Agriculture) || filteredEstateTypes.includes((0, $cUbQm.EstateType).RowHouse) || filteredEstateTypes.includes((0, $cUbQm.EstateType).OwnedApartment)) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dOPQH.RoomRangeSlider), {
                updateRangeTags: updateRangeTags,
                tabIndex: tabIndex
            }),
            (filteredEstateTypes.length === 0 || filteredEstateTypes.includes((0, $cUbQm.EstateType).House) || filteredEstateTypes.includes((0, $cUbQm.EstateType).Cottage) || filteredEstateTypes.includes((0, $cUbQm.EstateType).Cooperative) || filteredEstateTypes.includes((0, $cUbQm.EstateType).RowHouse) || filteredEstateTypes.includes((0, $cUbQm.EstateType).OwnedApartment)) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $8hO8H.LivingSpaceRangeSlider), {
                updateRangeTags: updateRangeTags,
                tabIndex: tabIndex
            })
        ]
    });
};
var $71fc51427b194050$export$2e2bcd8739ae039 = $71fc51427b194050$var$RangeSliders;

});
parcelRegister("8hO8H", function(module, exports) {

$parcel$export(module.exports, "LivingSpaceRangeSlider", function () { return $bb271d1faae034ff$export$8aefd41dde3aa761; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $a88f7 = parcelRequire("a88f7");

var $22cn8 = parcelRequire("22cn8");
const $bb271d1faae034ff$var$STEP = 10;
const $bb271d1faae034ff$var$MIN = 0;
const $bb271d1faae034ff$var$MAX = 200;
const $bb271d1faae034ff$export$8aefd41dde3aa761 = ({ tabIndex: tabIndex, updateRangeTags: updateRangeTags })=>{
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    const [liveLivingSpaceRange, setLiveLivingSpaceRange] = (0, $dTCkE.useState)([
        $bb271d1faae034ff$var$MIN,
        $bb271d1faae034ff$var$MAX
    ]);
    // reset range slider when tags is reset
    const [initValHasSet, setInitValHasSet] = (0, $dTCkE.useState)(false);
    (0, $dTCkE.useEffect)(()=>{
        if (filterContext.tags.length === 0) setLiveLivingSpaceRange([
            $bb271d1faae034ff$var$MIN,
            $bb271d1faae034ff$var$MAX
        ]);
        else if (!initValHasSet) {
            setInitValHasSet(true);
            const filterPriceTag = filterContext.tags.find((x)=>x.name === "Boarea" && x.type === "rangeTag");
            setLiveLivingSpaceRange([
                filterPriceTag?.minVal || $bb271d1faae034ff$var$MIN,
                filterPriceTag?.maxVal || $bb271d1faae034ff$var$MAX
            ]);
        } else {
            const filterPriceTag = filterContext.tags.find((x)=>x.name === "Boarea" && x.type === "rangeTag");
            setLiveLivingSpaceRange([
                filterPriceTag?.minVal || $bb271d1faae034ff$var$MIN,
                filterPriceTag?.maxVal || $bb271d1faae034ff$var$MAX
            ]);
        }
    }, [
        filterContext.tags,
        initValHasSet
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "mx-8",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("output", {
                className: "flex justify-between -mx-3 mt-3 mb-2 lg:mb-0 xxl:mb-2 text-base",
                id: "output",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "font-icb",
                        children: "Boarea"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        children: [
                            liveLivingSpaceRange[0],
                            "-",
                            liveLivingSpaceRange[1],
                            liveLivingSpaceRange[1] === $bb271d1faae034ff$var$MAX ? "+" : "",
                            "m\xb2"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a88f7.Range), {
                step: $bb271d1faae034ff$var$STEP,
                min: $bb271d1faae034ff$var$MIN,
                max: $bb271d1faae034ff$var$MAX,
                values: liveLivingSpaceRange,
                onChange: (LivingSpaceRange)=>{
                    setLiveLivingSpaceRange(LivingSpaceRange);
                },
                onFinalChange: ()=>{
                    updateRangeTags("Boarea", liveLivingSpaceRange[0], liveLivingSpaceRange[1]);
                },
                renderTrack: ({ props: props, children: children })=>/*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        onMouseDown: props.onMouseDown,
                        onTouchStart: props.onTouchStart,
                        className: "h-10 pointer-events-none lg:pointer-events-auto",
                        style: {
                            ...props.style,
                            display: "flex",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            ref: props.ref,
                            style: {
                                height: "3px",
                                width: "100%",
                                borderRadius: "4px",
                                background: (0, $a88f7.getTrackBackground)({
                                    values: liveLivingSpaceRange,
                                    colors: [
                                        "#ccc",
                                        "#005094",
                                        "#ccc"
                                    ],
                                    min: $bb271d1faae034ff$var$MIN,
                                    max: $bb271d1faae034ff$var$MAX,
                                    rtl: false
                                }),
                                alignSelf: "center"
                            },
                            children: children
                        })
                    }),
                renderThumb: ({ props: props, isDragged: isDragged })=>/*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        ...props,
                        className: "flex justify-evenly items-center bg-white shadow-bs40 p-2 border border-grey100 rounded-full outline-none w-8 h-8 pointer-events-auto slider-thumb",
                        tabIndex: tabIndex,
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: "w-[1px] h-3",
                                style: {
                                    backgroundColor: isDragged ? "#005094" : "#CCC"
                                }
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: "w-[1px] h-3",
                                style: {
                                    backgroundColor: isDragged ? "#005094" : "#CCC"
                                }
                            })
                        ]
                    })
            })
        ]
    });
};

});

parcelRegister("52Mqt", function(module, exports) {

$parcel$export(module.exports, "PriceRangeSlider", function () { return $51b0a3e02b21a5e7$export$eb8a5d830b6fa847; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $a88f7 = parcelRequire("a88f7");

var $22cn8 = parcelRequire("22cn8");

var $l8eky = parcelRequire("l8eky");
const $51b0a3e02b21a5e7$var$STEP = 100000;
const $51b0a3e02b21a5e7$var$MIN = 0;
const $51b0a3e02b21a5e7$var$MAX = 15000000;
const $51b0a3e02b21a5e7$export$eb8a5d830b6fa847 = ({ tabIndex: tabIndex, updateRangeTags: updateRangeTags })=>{
    const [priceRange, setPriceRange] = (0, $dTCkE.useState)([
        $51b0a3e02b21a5e7$var$MIN,
        $51b0a3e02b21a5e7$var$MAX
    ]);
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    const [initValHasSet, setInitValHasSet] = (0, $dTCkE.useState)(false);
    (0, $dTCkE.useEffect)(()=>{
        if (filterContext.tags.length === 0) setPriceRange([
            $51b0a3e02b21a5e7$var$MIN,
            $51b0a3e02b21a5e7$var$MAX
        ]);
        else if (!initValHasSet) {
            setInitValHasSet(true);
            const filterPriceTag = filterContext.tags.find((x)=>x.name === "Pris" && x.type === "rangeTag");
            setPriceRange([
                filterPriceTag?.minVal || $51b0a3e02b21a5e7$var$MIN,
                filterPriceTag?.maxVal || $51b0a3e02b21a5e7$var$MAX
            ]);
        } else {
            const filterPriceTag = filterContext.tags.find((x)=>x.name === "Pris" && x.type === "rangeTag");
            setPriceRange([
                filterPriceTag?.minVal || $51b0a3e02b21a5e7$var$MIN,
                filterPriceTag?.maxVal || $51b0a3e02b21a5e7$var$MAX
            ]);
        }
    }, [
        filterContext.tags,
        initValHasSet
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "mx-8",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("output", {
                className: "flex justify-between -mx-3 mt-3 mb-2 lg:mb-0 xxl:mb-2 text-base",
                id: "output",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "font-icb",
                        children: "Pris"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        children: [
                            (0, $l8eky.formatLargeNumbers)(priceRange[0]),
                            "-",
                            (0, $l8eky.formatLargeNumbers)(priceRange[1]),
                            priceRange[1] === $51b0a3e02b21a5e7$var$MAX ? "+" : "",
                            " SEK"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a88f7.Range), {
                step: $51b0a3e02b21a5e7$var$STEP,
                min: $51b0a3e02b21a5e7$var$MIN,
                max: $51b0a3e02b21a5e7$var$MAX,
                values: priceRange,
                onChange: (priceRange)=>{
                    setPriceRange(priceRange);
                },
                onFinalChange: ()=>{
                    updateRangeTags("Pris", priceRange[0], priceRange[1]);
                },
                renderTrack: ({ props: props, children: children })=>/*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        onMouseDown: props.onMouseDown,
                        onTouchStart: props.onTouchStart,
                        className: "h-10 pointer-events-none lg:pointer-events-auto",
                        style: {
                            ...props.style,
                            display: "flex",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            ref: props.ref,
                            style: {
                                height: "3px",
                                width: "100%",
                                borderRadius: "4px",
                                background: (0, $a88f7.getTrackBackground)({
                                    values: priceRange,
                                    colors: [
                                        "#ccc",
                                        "#005094",
                                        "#ccc"
                                    ],
                                    min: $51b0a3e02b21a5e7$var$MIN,
                                    max: $51b0a3e02b21a5e7$var$MAX,
                                    rtl: false
                                }),
                                alignSelf: "center"
                            },
                            children: children
                        })
                    }),
                renderThumb: ({ props: props, isDragged: isDragged })=>/*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        ...props,
                        className: "flex justify-evenly items-center bg-white shadow-bs40 p-2 border border-grey100 rounded-full outline-none w-8 h-8 pointer-events-auto slider-thumb",
                        tabIndex: tabIndex,
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: "w-[1px] h-3",
                                style: {
                                    backgroundColor: isDragged ? "#005094" : "#CCC"
                                }
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: "w-[1px] h-3",
                                style: {
                                    backgroundColor: isDragged ? "#005094" : "#CCC"
                                }
                            })
                        ]
                    })
            })
        ]
    });
};

});

parcelRegister("dOPQH", function(module, exports) {

$parcel$export(module.exports, "RoomRangeSlider", function () { return $f526f5b26f84eaee$export$62f11dbeb209dc2c; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $a88f7 = parcelRequire("a88f7");

var $22cn8 = parcelRequire("22cn8");
const $f526f5b26f84eaee$var$STEP = 1;
const $f526f5b26f84eaee$var$MIN = 0;
const $f526f5b26f84eaee$var$MAX = 10;
const $f526f5b26f84eaee$export$62f11dbeb209dc2c = ({ tabIndex: tabIndex, updateRangeTags: updateRangeTags })=>{
    const [roomRange, setRoomRange] = (0, $dTCkE.useState)([
        $f526f5b26f84eaee$var$MIN,
        $f526f5b26f84eaee$var$MAX
    ]);
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    const [initValHasSet, setInitValHasSet] = (0, $dTCkE.useState)(false);
    (0, $dTCkE.useEffect)(()=>{
        if (filterContext.tags.length === 0) setRoomRange([
            $f526f5b26f84eaee$var$MIN,
            $f526f5b26f84eaee$var$MAX
        ]);
        else if (!initValHasSet) {
            setInitValHasSet(true);
            const filterPriceTag = filterContext.tags.find((x)=>x.name === "Rum" && x.type === "rangeTag");
            setRoomRange([
                filterPriceTag?.minVal || $f526f5b26f84eaee$var$MIN,
                filterPriceTag?.maxVal || $f526f5b26f84eaee$var$MAX
            ]);
        } else {
            const filterPriceTag = filterContext.tags.find((x)=>x.name === "Rum" && x.type === "rangeTag");
            setRoomRange([
                filterPriceTag?.minVal || $f526f5b26f84eaee$var$MIN,
                filterPriceTag?.maxVal || $f526f5b26f84eaee$var$MAX
            ]);
        }
    }, [
        filterContext.tags,
        initValHasSet
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "mx-8",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("output", {
                className: "flex justify-between -mx-3 mt-3 mb-2 lg:mb-0 xxl:mb-2 text-base",
                id: "output",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "font-icb",
                        children: "Antal rum"
                    }),
                    roomRange[0],
                    "-",
                    roomRange[1],
                    roomRange[1] === $f526f5b26f84eaee$var$MAX ? "+" : "",
                    " rum"
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a88f7.Range), {
                step: $f526f5b26f84eaee$var$STEP,
                min: $f526f5b26f84eaee$var$MIN,
                max: $f526f5b26f84eaee$var$MAX,
                values: roomRange,
                onChange: (roomRange)=>{
                    setRoomRange(roomRange);
                },
                onFinalChange: ()=>{
                    updateRangeTags("Rum", roomRange[0], roomRange[1]);
                },
                renderTrack: ({ props: props, children: children })=>/*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        onMouseDown: props.onMouseDown,
                        onTouchStart: props.onTouchStart,
                        className: "h-10 pointer-events-none lg:pointer-events-auto",
                        style: {
                            ...props.style,
                            display: "flex",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            ref: props.ref,
                            style: {
                                height: "3px",
                                width: "100%",
                                borderRadius: "4px",
                                background: (0, $a88f7.getTrackBackground)({
                                    values: roomRange,
                                    colors: [
                                        "#ccc",
                                        "#005094",
                                        "#ccc"
                                    ],
                                    min: $f526f5b26f84eaee$var$MIN,
                                    max: $f526f5b26f84eaee$var$MAX,
                                    rtl: false
                                }),
                                alignSelf: "center"
                            },
                            children: children
                        })
                    }),
                renderThumb: ({ props: props, isDragged: isDragged })=>/*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        ...props,
                        className: "flex justify-evenly items-center bg-white shadow-bs40 p-2 border border-grey100 rounded-full outline-none w-8 h-8 pointer-events-auto slider-thumb",
                        tabIndex: tabIndex,
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: "w-[1px] h-3",
                                style: {
                                    backgroundColor: isDragged ? "#005094" : "#CCC"
                                }
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: "w-[1px] h-3",
                                style: {
                                    backgroundColor: isDragged ? "#005094" : "#CCC"
                                }
                            })
                        ]
                    })
            })
        ]
    });
};

});


parcelRegister("i3fhg", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKMi"))((parcelRequire("i55FY")).resolve("avyxO")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("fktX1"))
]).then(()=>parcelRequire("bqfGL"));

});

parcelRegister("2K6uN", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("ePaqb")).then(()=>parcelRequire("5gMlP"));

});

parcelRegister("6887U", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7btFY")).then(()=>parcelRequire("5QkOU"));

});

parcelRegister("7GeXm", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4pNop")).then(()=>parcelRequire("2EklW"));

});


parcelRegister("gLK27", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccb75271af98769a$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $22cn8 = parcelRequire("22cn8");

var $cUbQm = parcelRequire("cUbQm");
const $ccb75271af98769a$var$ExtraFilterBtn = ({ setTabIndex: setTabIndex, tabIndex: tabIndex, showExtraCriterias: showExtraCriterias, setShowExtraCriterias: setShowExtraCriterias })=>{
    const [filterText, setFilterText] = (0, $dTCkE.useState)("Visa fler filter");
    const element = document.getElementById("extra-criterias");
    const arrow = document.getElementById("extra-criterias-arrow");
    const filterContext = (0, $dTCkE.useContext)((0, $22cn8.FilterContext));
    const existingTag = filterContext.tags.find((x)=>x.type === (0, $cUbQm.FilterParams).ESTATETYPE_PARAM);
    function toggleExtraCriterias() {
        arrow?.classList.toggle("rotate-180");
        [
            "max-h-7xl"
        ].map((x)=>element?.classList.toggle(x));
        if (tabIndex !== 0) setTabIndex(0);
        else setTabIndex(-1);
        if (!showExtraCriterias) {
            setShowExtraCriterias(true);
            setFilterText("D\xf6lj filter");
        } else {
            setShowExtraCriterias(false);
            setFilterText("Visa fler filter");
        }
    }
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
        className: `select-none px-8 mb-6 pb-1 mt-2 text-center text-blue700 mx-auto flex hover:cursor-pointer focus:outline-none button ${showExtraCriterias ? "lg:mb-8" : ""} ${existingTag === undefined || existingTag?.estateType === (0, $cUbQm.EstateType).Project ? "lg:hidden" : ""}`,
        onClick: toggleExtraCriterias,
        type: "button",
        children: [
            filterText,
            /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                width: "20",
                height: "20",
                id: "extra-criterias-arrow",
                className: "w-5 self-center transform ml-4",
                src: "/Images/Icons/Arrows/arrow-down-black500.svg",
                alt: "pil-ikon"
            })
        ]
    });
};
var $ccb75271af98769a$export$2e2bcd8739ae039 = $ccb75271af98769a$var$ExtraFilterBtn;

});


})();
//# sourceMappingURL=FilterEstatesComponent.b37e9c97.js.map
